<template>
    <div>
        <!-- Header Start -->
        <header class="main-header header-fw can-sticky header-1">
            <nav class="navbar">

                <div class="col-lg-2 col-5 text-left" >
                    <!-- Logo -->
                    <a class="navbar-brand" href="https://henzagold.shop">
                        <logo width="220px"/>
                    </a>
                </div>
                <div class="col-lg-10 col-7 d-flex" >
                    <ul class="navbar-nav">
                        <!-- Pages Start -->
                        <li class="menu-item">
                            <a href="https://henzagold.shop/">بازگشت به فروشگاه</a>
                        </li>
<!--                        <li class="menu-item menu-item-has-children" v-for="(item, index) in menu" :key="index">-->

<!--                            <a :href="menu[index].is_master ? `https://henzagold.shop/shop?cat=${menu[index].id}` : `#`">{{ menu[index].title }}</a>-->
<!--                            <ul class="submenu" v-if="menu[index].childs.length>0">-->
<!--                                <li class="menu-item" v-for="(itemChild,indexChild) in item.childs" :key="indexChild">-->
<!--                                    <a :href="`https://henzagold.shop/shop?cat=${menu[index].childs[indexChild].id}`">{{ menu[index].childs[indexChild].title }}</a>-->
<!--                                </li>-->
<!--                            </ul>-->
<!--                        </li>-->
                    </ul>
                    <div class="header-controls mr-lg-3" >

                        <!-- Toggler -->
                        <div class="aside-toggler aside-trigger" @click="toggleMenu" style="margin-right:5px;margin-left:20px">
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>

<!--                        <div class="mr-1">-->
<!--                            <router-link to="/customer" style="color:#21284e">-->
<!--                                <svg style="width:28px;height:28px" viewBox="0 0 24 24">-->
<!--                                    <path fill="currentColor" d="M12,4A4,4 0 0,1 16,8A4,4 0 0,1 12,12A4,4 0 0,1 8,8A4,4 0 0,1 12,4M12,6A2,2 0 0,0 10,8A2,2 0 0,0 12,10A2,2 0 0,0 14,8A2,2 0 0,0 12,6M12,13C14.67,13 20,14.33 20,17V20H4V17C4,14.33 9.33,13 12,13M12,14.9C9.03,14.9 5.9,16.36 5.9,17V18.1H18.1V17C18.1,16.36 14.97,14.9 12,14.9Z" />-->
<!--                                </svg>-->
<!--                            </router-link>-->
<!--                        </div>-->
                        <div class="position-relative" style="margin-right: 30px">
                            <cart/>
                        </div>

                    </div>
                </div>

            </nav>


            <!-- Top Header Start -->
            <div class="top-header pr-lg-5">
                <div class="top-header-inner" style="height: 1.5rem">

                    <ul class="top-header-nav d-lg-flex " style="justify-content: flex-start" v-if="goldPrice && goldPrice.geram18 && goldPrice.mesghal && goldPrice.geram24">
                        <li class="brand-item d-none d-lg-block" >
                            <a> {{goldPrice.geram18.uaj }} </a>
                        </li>
                        <li  class="brand-item d-none d-md-block" >
                            <a>مثقال طلا : {{ goldPrice.mesghal.p | tomanPriceUnit }} </a>
                        </li>
                        <li  class="brand-item" >
                            <a> گرم طلای 18 عیار : {{ goldPrice.geram18.p | tomanPriceUnit }} </a>
                        </li>
<!--                        <li  class="brand-item" >-->
<!--                            <a>گرم طلای 24 عیار : {{ goldPrice.geram24.p | tomanPriceUnit }} </a>-->
<!--                        </li>-->
                    </ul>
                </div>
            </div>
            <!-- Top Header End -->
        </header>
        <!-- Header End -->
    </div>
</template>

<script>
import Logo from "./Logo";
// import MobileMenu from "./MobileMenu";
import Cart from "./Cart";
import axios from '@/plugins/axios'
export default {
  name: "PageHeader",
  components:{
    Cart,
    // MobileMenu,
    Logo,
  },
  data () {
    return {
      // menu: [],
      goldPrice: undefined
    }
  },
  methods:{
    toggleMenu () {
      document.getElementById("mobileMenu").classList.toggle('open');
      document.body.classList.toggle('aside-open');
    }

  },
  async created() {
      const appLoading = document.getElementById('loading-bg')
      try {
        if (appLoading) {
          appLoading.classList.add = "hidden";
        }
        let {data} = await axios.get('site/price');
        if (data) {
          await this.$store.dispatch('config/initPrice',data);
          this.goldPrice = this.$store.state.config.price
        }
      }
      catch (error) {
        if (error.response && error.response.data.errors) {
          let str_error = ''
          for(let item of Object.values(error.response.data.errors))
          {
            item.map(xx=>{
              if (xx.includes("shipping address")){
                str_error += xx.replace("shipping address","آدرس") + "<br/>"
              }
              else{
                str_error += xx + "<br/>"
              }
            })
          }
          this.$vs.notify({title:'خطایی رخ داد',time:3500,text:str_error,color:'var(--secondary-color)',icon:'error_outline'})
        }
        else{
          if (error) {
            if(error == "Error: Network Error"){
              this.$vs.notify({title:'خطایی رخ داد',time:3500,text:"اتصال برقرار نشد",color:'var(--secondary-color)',icon:'error_outline'})
            }
            else {
              this.$vs.notify({title:'خطایی رخ داد',time:3500,text:error,color:'var(--secondary-color)',icon:'error_outline'})
            }
          }
        }
      }
      finally {
        if (appLoading) {
          appLoading.classList.remove = "hidden";
        }
      }



        // Sticky Header
        var header = document.getElementsByClassName("can-sticky")[0];
        if (header){
            var headerHeight = header.clientHeight;
        }
        function doSticky() {
            if (window.pageYOffset > headerHeight) {
                header.classList.add("sticky");
            } else {
                header.classList.remove("sticky");
            }
        }
        doSticky();
        //On scroll events
        window.onscroll = function() {
            doSticky();
        }
    }
}
</script>

<style scoped>
    .brand-item{
        margin: 0 5px;
        color:#fff;
    }
</style>
